import { createContext } from "react";

export const TableRowColumnIndexContex = createContext();